"use client";
// @ts-strict-ignore
import React from "react";
import type { CryptopediaCategoryType } from "types/cryptopedia";
import { getCategoryUrl, getParentCategories } from "utils/cryptopedia";
import { logger } from "observability";
import { FALLBACK_TOP_CATEGORIES } from "app/_components/layout/Header/CryptopediaHeader/const";
import {
  Backdrop,
  CloseButton,
  MobileSideNavContainer,
  MenuContainer,
  MobileSideNavSignInButton
} from "./styles";
import { HTMLButton } from "components/parts/button";
import NextLink from "components/parts/NextLink";
import { AnimatePresence } from "framer-motion";
import CloseIcon from "public/images/cryptopedia/close-icon.svg?inline";
import { Flex, Text } from "@hubble/web";
import NextImage from "components/parts/NextImage";
import { EXCHANGE_BASE_URL } from "config/index";
import { mixpanelClient } from "analytics/mixpanel";

const MobileSideNav = ({ isOpen = false, onClose }) => {
  const [categories, setCategories] = React.useState<CryptopediaCategoryType[]>(
    []
  );
  React.useEffect(() => {
    const getTopCategories = async () => {
      try {
        const categories = await getParentCategories();
        setCategories(categories);
      } catch (e) {
        logger.error("Error getting cryptopedia categories for mobile nav", e);
        setCategories(FALLBACK_TOP_CATEGORIES);
      }
    };
    getTopCategories();
  }, []);

  return (
    <React.Fragment>
      <MobileSideNavContainer
        initial={false}
        animate={{
          left: isOpen
            ? 0
            : typeof window !== "undefined"
              ? -window.innerWidth
              : -600
        }}
        transition={{ ease: "easeInOut", duration: 0.3 }}
      >
        <HTMLButton onClick={onClose}>
          <CloseButton src={CloseIcon} alt={"close"} />
        </HTMLButton>
        <MenuContainer>
          <Text.Body
            underline={false}
            size="sm"
            bold
            marketing
            color={"#808181"}
            mb={3}
          >
            Topics
          </Text.Body>

          {categories.map((category) => (
            <NextLink href={getCategoryUrl(category.name)} key={category.id}>
              <Text.Body underline={false} size="xl" bold marketing mb={3}>
                {category.name}
              </Text.Body>
            </NextLink>
          ))}
          <NextLink href="/cryptopedia/explore">
            <Text.Body underline={false} size="xl" bold marketing mb={3}>
              View all
            </Text.Body>
          </NextLink>
        </MenuContainer>
        <Flex flexDirection="column" gap="1rem">
          <Flex alignItems="center">
            <Text.Body size="sm" bold marketing color="#808181">
              Powered by
            </Text.Body>
            &nbsp;
            <NextImage
              src="https://cdn.builder.io/api/v1/image/assets/1b77ce3a269a43e985e77f3d65f715ba/5b06e731d3c241398922ea1e58f71017"
              alt="Gemini Logo"
              width={66}
              height={15}
              onClick={() => {
                mixpanelClient.track(
                  "Cryptopedia Mobile sidenav - Gemini logo clicked"
                );
                window.open(EXCHANGE_BASE_URL, "_blank");
              }}
            />
          </Flex>
          <NextLink
            onClick={() => {
              mixpanelClient.track(
                "Cryptopedia mobile nav - Gemini Sign in clicked"
              );
            }}
            href={`${EXCHANGE_BASE_URL}/signin`}
            target="_blank"
            id="cryptopedia-header-signin-mobile"
          >
            <Text.Body size="sm" bold marketing>
              Sign in
            </Text.Body>
          </NextLink>
        </Flex>
        <MobileSideNavSignInButton
          onClick={() => {
            mixpanelClient.track("Cryptopedia mobile nav - Buy Crypto clicked");
          }}
          size="lg"
          href={`${EXCHANGE_BASE_URL}/register`}
          target="_blank"
        >
          <Text.Body size="sm" bold color="inherit">
            Buy crypto
          </Text.Body>
        </MobileSideNavSignInButton>
      </MobileSideNavContainer>
      <AnimatePresence>
        {!!isOpen && (
          <Backdrop
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
          />
        )}
      </AnimatePresence>
    </React.Fragment>
  );
};

export default MobileSideNav;
